var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleLandscape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    strokeWidth: 1.5,
    transform: "translate(1 .667)",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.625 2.708v-.815A1.676 1.676 0 0013.958.208H2.292A1.676 1.676 0 00.625 1.893v7.88a1.676 1.676 0 001.667 1.685M9.45 16.458l3.698-5.255a1.25 1.25 0 011.965-.107l4.114 4.702M9.063 8.958a.313.313 0 110 .625.313.313 0 010-.625"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5.208,
    width: 14.375,
    height: 11.25,
    rx: 1.029
  }))));
}
export default SvgDoubleLandscape;